import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled/stack';

import { SnippetPanelSearchBarSkeleton } from './SnippetPanelSearchBarSkeleton.tsx';
import { SnippetCategorySelectorSkeleton } from './SnippetCategorySelectorSkeleton.tsx';
import { SnippetSortDropdownSkeleton } from './SnippetSortDropdownSkeleton.tsx';
import { SnippetPanelItemSkeleton } from './SnippetPanelItemSkeleton.tsx';

export const SnippetPanelSkeleton = (): React.JSX.Element => {
	return (
		<Stack space="space.200" grow="fill">
			<SnippetPanelSearchBarSkeleton />
			<SnippetCategorySelectorSkeleton />
			<SnippetSortDropdownSkeleton />
			<Stack>
				<SnippetPanelItemSkeleton />
				<SnippetPanelItemSkeleton />
				<SnippetPanelItemSkeleton />
			</Stack>
		</Stack>
	);
};
